module.exports = __webpack_public_path__ + "img/Bahnhof_Anina_kl.7d38022a.jpg";